import { FC } from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigateBackByLocationState } from './hooks/useNavigateBackByLocationState';
import { Button } from 'src/components/Buttons/Button';
import { Logo } from 'src/config/components/Logo';

interface ErrorGamePageProps {
  errorMessage: string;
}

export const ErrorGamePage: FC<ErrorGamePageProps> = ({ errorMessage }) => {
  const { t } = useTranslation();

  const handelBack = useNavigateBackByLocationState();

  return (
    <div className="flex !h-screen w-full items-center justify-center rounded-b-lg px-3 1024:mb-10 1024:h-full">
      <div className="flex flex-col items-center pb-20 h-fit">
        <Logo className="w-[200px] h-[200px] mb-2 object-contain" />
        <h1 className="mb-5 max-w-[310px] text-center text-sm text-white 768:max-w-[450px] 768:text-base">
          {errorMessage}
        </h1>
        <Button
          mode="button-primary"
          onClick={handelBack}
          className="w-min min-w-[200px] max-w-[200px]">
          {t('gameError.buttonTitle')}
        </Button>
      </div>
    </div>
  );
};
